export default __webpack_public_path__ + "static/media/panel-brands.79c7a362.svg";